import React, { useState, useEffect } from 'react';
import { TableToolbar, TableToolbarContent, TableToolbarSearch, TableToolbarMenu, Checkbox } from 'carbon-components-react';
import axios from "axios";
import moment from 'moment';

import DashboardSummary from '../DashboardSummaryNew';
import callPostApi from 'requests/PostRequests';
import * as Constants from '../../../requests/URLConstants';
import DashboardLineChart from '../DashboardLineChart';
import DashboardTable from '../DashboardTable';
import * as DashboardUtils from '../DashboardUtils.js';
import * as tableHeaders from './tableHeaders';
import TableToolbarDownload from '../../../common/TableToolbarDownload';
import * as DashboardConstants from '.././DashboardConstants';
import { sampleReportData } from './tableHeaders';
import * as workspaces from '../../../config/WorkspaceConstants'

const Juniper = (props) => {
    const [JuniperIncidentReportLoading, setJuniperIncidentReportLoading] = useState(true);
    const [JuniperTicketsLoading, setJuniperTicketsLoading] = useState(true);
    const [JuniperTicketsData, setJuniperTicketsData] = useState([]);
    const [JuniperIncidentReportData, setJuniperIncidentReportData] = useState([]);
    const [searchedJuniperReportData, setSearchedJuniperReportData] = useState([]);
    const [juniperSummaryLoading, setJuniperSummaryLoading] = useState(true);
    const [filteredTableHeaders, setFilteredTableHeaders] = useState([]);
    const [juniperSummary, setJuniperSummary] = useState([]);
    const [predictionReport, setPredictionReport] = useState([]);
    const [predictionReportLoading, setPredictionReportLoading] = useState(true);
    const [searchedPredictedReport, setSearchedPredictedReport] = useState([]);

    useEffect(() => {
        getJuniperSummaryData(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getIncidentsTicketTrend(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getJuniperIncidentReport(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getJuniperPredictionReport(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    }, [props.preferencesChanged])

    const prepareJuniperIncidentReport = (response) => {
        let tableData = [];
        let tableObj = {};
        if (response.body) {
            let buckets = response.body.aggregations.incident_number.buckets;
            //console.log(buckets)
            for (let i = 0; i < buckets.length; i++) {
                let incidentId = buckets[i]
                let priority = incidentId.priority.buckets[0]
                let summary = priority.summary.buckets[0];
                let description = summary.descripion.buckets.length ? summary.descripion.buckets[0] : 0;
                let ticketType = description ? description.ticket_type.buckets[0] : 0;
                let rootCause = ticketType ? ticketType.root_cause.buckets[0] : 0;
                let category = rootCause ? rootCause.category.buckets[0] : 0;
                let assignmentGroup = category ? category.assignment_group.buckets[0] : 0;
                let createdDate = assignmentGroup ? assignmentGroup.incident_created.buckets[0] : 0;
                let createdTime = createdDate ? moment(new Date(createdDate.key_as_string)).format("hh:mm:ss") : '';
                let client = createdDate ? createdDate.project_client.buckets[0] : 0;
                let actionedBySME = client ? client.actioned_by_sme.buckets[0] : 0;
                let changedResolutionSteps = actionedBySME ? actionedBySME.changed_resolution.buckets[0] : 0;
                let changedRootCause = changedResolutionSteps ? changedResolutionSteps.changed_root_cause.buckets[0] : 0;
                let changedAssignmentGroup = changedRootCause ? changedRootCause.changed_assignment_group.buckets[0] : 0;

                tableObj = {
                    id: i + 1,
                    incidentId: incidentId.key ? incidentId.key : '-',
                    priority: priority.key ? priority.key : '-',
                    summary: summary.key ? summary.key : '-',
                    description: description.key ? description.key : '-',
                    ticketType: ticketType.key ? ticketType.key : '-',
                    rootCause: rootCause.key ? rootCause.key : '-',
                    category: category.key ? category.key : '-',
                    assignmentGroup: assignmentGroup.key ? assignmentGroup.key : '-',
                    createdDate: createdDate.key ? moment(new Date(createdDate.key_as_string)).format("YYYY-MM-DD") : '',
                    createdTime: createdTime,
                    client: client.key ? client.key : '-',
                    actionedBySME: actionedBySME.key ? actionedBySME.key : '-',  //(actionedBySME.key === 'R' || actionedBySME.key === 'A') ? 'Y' : 'N' : '-',
                    changedResolutionSteps: changedResolutionSteps.key ? changedResolutionSteps.key === '__missing__' ? '-' : changedResolutionSteps.key : '-',
                    changedRootCause: changedResolutionSteps.key ? changedResolutionSteps.key === '__missing__' ? '-' : changedResolutionSteps.key : '-',
                    changedAssignmentGroup: changedAssignmentGroup.key ? changedAssignmentGroup.key === '__missing__' ? '-' : changedAssignmentGroup.key : '-'

                };
                tableData.push(tableObj);
            }
        }
        return { tableData };
    };

    const getJuniperIncidentReport = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setJuniperIncidentReportLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETJUNIPERINCIDENTREPORT, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareJuniperIncidentReport(resp);
                    setJuniperIncidentReportData(formattedData.tableData);
                    setJuniperIncidentReportLoading(false);
                }).catch((error) => {
                    setJuniperIncidentReportLoading(false);
                });
        }
    }

    const prepareJuniperTicketTrendData = (response) => {
        if (response.body) {
            let graphData = [];
            let incidentCountObj = {};
            let buckets = response.body.aggregations.time.buckets;
            for (let i = 0; i < buckets.length; i++) {
                incidentCountObj = {
                    "group": 'Tickets',
                    "date": moment(new Date(buckets[i].key_as_string)).format("YYYY-MM-DD"),
                    "value": buckets[i].incident_count.value
                };
                graphData.push(incidentCountObj);
            }
            return graphData;
        }
    }

    function getIncidentsTicketTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setJuniperTicketsLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETJUNIPERTICKETSTREND, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareJuniperTicketTrendData(resp);
                    setJuniperTicketsData(formattedData);
                    setJuniperTicketsLoading(false);
                }).catch((error) => {
                    setJuniperTicketsLoading(false);
                });
        }
    }

    function getJuniperSummaryData(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setJuniperSummaryLoading(true);
            let formattedData = {};
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETJUNIPERTICKETSSUMMARY, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = resp.body.aggregations;
                    getJuniperSummary(formattedData);
                    setJuniperSummaryLoading(false);
                }).catch((error) => {
                    setJuniperSummaryLoading(false);
                })
        }
    }

    function getJuniperPredictionReport(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            //setJuniperSummaryLoading(true);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETPREDICTIONREPORT, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    console.log(resp);
                    preparePredictionReport(resp);
                    setPredictionReportLoading(false);
                }).catch((error) => {
                    setPredictionReportLoading(false);
                })
        }
    }

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {

        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if (workspace === workspaces.automation_ops) {
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client = dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                    "geos": dashboardFilterSelectionsAutomation.geo,
                    "assignment_groups": dashboardFilterSelectionsAutomation.assigned_group,
                    "business_competencies": dashboardFilterSelectionsAutomation.competency,
                    "incident_status": dashboardFilterSelectionsAutomation.incident_status,
                    "automata_priority": dashboardFilterSelectionsAutomation.priority
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        } else {
            technology = ["SAP"];
            franchise = dashboardFilterSelectionsSAP.franchise;
            client = dashboardFilterSelectionsSAP.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "assignment_groups": dashboardFilterSelectionsSAP.assigned_group,
                    "incident_status": dashboardFilterSelectionsSAP.incident_status,
                    "automata_priority": dashboardFilterSelectionsSAP.priority
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        }

        return bodyJSON;
    };

    const getJuniperSummary = (resp) => {

        let tickets = isNaN(resp.tickets.value) ? 0 : resp.tickets.value;
        let processedWithChange = isNaN(resp.processed_with_change.value) ? 0 : resp.processed_with_change.value;
        let processedWithPrediction = isNaN(resp.processed_with_prediction.value) ? 0 : resp.processed_with_prediction.value;
        let yetToProcess = resp.tickets.value - (resp.processed_with_prediction.value + resp.processed_with_change.value)
        let summary = [
            {
                title: DashboardConstants.Tickets,
                value: tickets
            },
            {
                title: DashboardConstants.YetToBeProcessed,
                value: yetToProcess
            },
            {
                title: DashboardConstants.ProcessedWithPrediction,
                value: processedWithPrediction
            },
            {
                title: DashboardConstants.ProcessedWithChange,
                value: processedWithChange
            }
        ];
        setJuniperSummary(summary);
    };

    const searchTable = (event, reportType) => {
        let searchString = event.target.value.toUpperCase();
        let searchResult = [];
        let newList = [];
        let string, pattern;
        let matchedStrings;
        let juniperReportData = reportType === "IncidentReport" ? JuniperIncidentReportData : predictionReport;
        if (searchString) {
            newList = juniperReportData.filter((element) => {
                for (var property in element) {
                    if (element.hasOwnProperty(property)) {
                        string = element[property] ? element[property] : "";
                        string = string ? string.toString() : "";
                        pattern = new RegExp("(\\w*" + searchString + "\\w*)", "gi");
                        matchedStrings = string.match(pattern);
                        if (matchedStrings && matchedStrings.length) {
                            searchResult = searchResult.concat([element]);
                            return searchResult;
                        }
                    }
                }
            });
            reportType === "IncidentReport" ? setSearchedJuniperReportData(newList) : setSearchedPredictedReport(newList);

        } else {
            reportType === "IncidentReport" ? setSearchedJuniperReportData(juniperReportData) : setSearchedPredictedReport(juniperReportData);
        }
    };

    const manageHeader = (checked, id) => {
        let headers = tableHeaders.reportTableHeaders;
        headers.forEach(header => {
            if (header.key === id) {
                header.hidden = !checked;
            }
        });
        let filteredheader = headers.filter(header => header.hidden === false);
        setFilteredTableHeaders(filteredheader);
    };

    const preparePredictionReport = (resp) => {
        let predictionArr = resp.body.hits.hits;
        console.log(predictionArr);
        let predictionData = []; let predectionObj = {};
        for (let i = 0; i < predictionArr.length; i++) {
            predectionObj = {
                id: i,
                incidentId: predictionArr[i]._source.incident_id,
                priority: predictionArr[i]._source.priority,
                summary: predictionArr[i]._source.info,
                snowCategory: predictionArr[i]._source.category,
                snowAssignmentGroup: predictionArr[i]._source.suppGrp,
                predictedCategory: predictionArr[i]._source.classification.predicted_category,
                predictedAssignementGroup: predictionArr[i]._source.classification.predicted_owner,
                matchCategory: predictionArr[i]._source.category === predictionArr[i]._source.classification.predicted_category ? 'True' : 'False',
                matchAssignmentGroup: predictionArr[i]._source.suppGrp === predictionArr[i]._source.classification.predicted_owner ? 'True' : 'False',
                createdDate: predictionArr[i]._source.alertTime,
                closureDate: predictionArr[i]._source.lastUpdateTime,
                actionedBySME: predictionArr[i].fields.Actioned_By_SME[0],
            }
            predictionData.push(predectionObj);
            console.log(predictionData);
        }
        setPredictionReport(predictionData);
    }

    return (
        <div className="top-margin dashboard incident-management">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer col-lg-12">
                    <DashboardSummary loading={juniperSummaryLoading} summary={juniperSummary} title={DashboardConstants.ServiceDeskTriageSummary} />
                </div>
                <div className="dashboard-charts-container">
                    <div className="report-title">
                        <div>{DashboardConstants.DetailedView}</div>
                    </div>
                    <section className="border-bottom">
                        <DashboardLineChart
                            lineGraphData={JuniperTicketsData}
                            loading={JuniperTicketsLoading}
                            title={DashboardConstants.Tickets}
                            graphXAxisTitle={DashboardConstants.Month}
                            graphTitle={DashboardConstants.TotalTicketsCount}
                        />
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            {DashboardConstants.Report}
                            <div className="table-toolbar">
                                <TableToolbar>
                                    <TableToolbarContent>
                                        <TableToolbarSearch onChange={(event) => searchTable(event, "IncidentReport")} />
                                    </TableToolbarContent>
                                </TableToolbar>
                                <TableToolbarMenu light iconDescription="Headers">
                                    <fieldset className="optional-headers">
                                        {tableHeaders.reportTableHeaders.map(header => (header.optional ? <Checkbox labelText={header.header} checked={!header.hidden} onChange={manageHeader} id={header.key} /> : null))}
                                    </fieldset>
                                </TableToolbarMenu>
                                <div className="download-button">
                                    <TableToolbarDownload iconDescription="Export" rows={JuniperIncidentReportData} headers={tableHeaders.reportTableHeaders}
                                        title="Report" filename="JuniperReport" label="Download"
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="bold-border-table">
                            <DashboardTable loading={JuniperIncidentReportLoading} rows={searchedJuniperReportData.length ? searchedJuniperReportData : JuniperIncidentReportData}
                                headers={filteredTableHeaders.length ? filteredTableHeaders : tableHeaders.reportTableHeaders.filter(header => header.hidden === false)}
                                showPagination={true} isSortingAllowed={true} />
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            {DashboardConstants.PredictionReport}
                            <div className="table-toolbar">
                                <TableToolbar>
                                    <TableToolbarContent>
                                        <TableToolbarSearch onChange={(event) => searchTable(event, "PredictionReport")} />
                                    </TableToolbarContent>
                                </TableToolbar>
                                <TableToolbarMenu light iconDescription="Headers">
                                    <fieldset className="optional-headers">
                                        {tableHeaders.predictionReportHeaders.map(header => (header.optional ? <Checkbox labelText={header.header} checked={!header.hidden} onChange={manageHeader} id={header.key} /> : null))}
                                    </fieldset>
                                </TableToolbarMenu>
                                <div className="download-button">
                                    <TableToolbarDownload iconDescription="Export" rows={predictionReport} headers={tableHeaders.predictionReportHeaders}
                                        title="Report" filename="JuniperReport" label="Download"
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="bold-border-table">
                            <DashboardTable loading={predictionReportLoading} rows={searchedPredictedReport.length ? searchedPredictedReport : predictionReport}
                                headers={filteredTableHeaders.length ? filteredTableHeaders : tableHeaders.predictionReportHeaders.filter(header => header.hidden === false)}
                                showPagination={true} isSortingAllowed={true} />
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Juniper;
